// ** Third Party Components
import loadable from "@loadable/component";

// ** Custom Components
import Block from "components/layout/Block";

// ** Media Type Components

const MediaImage = loadable(() => import("./components/MediaImage"));
const MediaVideo = loadable(() => import("./components/MediaVideo"));

// ** Utils & Helpers
import convertText from "utils/convertText";

// ** Styled Components
import {
	StyledMediaTypeContainer,
	StyledMediaTypeContainerFull,
	StyledMediaTypeLink,
	StyledTextWrapper,
	StyledMediaTypePaddingContainerMobile,
} from "./styles";

// #####################################################

const MediaType = ({
	type,
	item,
	isAuth,
	isPhone,
	size,
	to,
	simple,
	userLogin,
	children,
	removePaddingOnMobile,
	showDescription = true,
}) => {
	// #####################################################

	if (type === "post") {
		return (
			<Block>
				<StyledTextWrapper
					removePaddingOnMobile={removePaddingOnMobile}
				>
					{userLogin}
					<Block flex column>
						{showDescription && (
							<Block>
								{convertText({
									pieces: item.description ?? item.text,
								})}
							</Block>
						)}
						{!simple && children && (
							<Block mt={3}>{children}</Block>
						)}
					</Block>
				</StyledTextWrapper>
			</Block>
		);
	}

	return (
		<>
			<StyledMediaTypeContainerFull
				removePaddingOnMobile={removePaddingOnMobile}
			>
				<StyledMediaTypePaddingContainerMobile>
					{userLogin}
				</StyledMediaTypePaddingContainerMobile>
				<StyledMediaTypeContainer flex justifyCenter>
					<StyledMediaTypeLink
						noScroll
						to={
							isAuth
								? {
										hash: to.toLowerCase(),
										search: location.search,
								  }
								: "/"
						}
						onClick={() => !isAuth && window.scrollTo(0, 0)}
					>
						{type === "video" ? (
							<MediaVideo
								type={type}
								width={item.width}
								height={item.height}
								maxHeight={isPhone ? 400 : 500}
								thumbnail={
									item.media?.thumbs.poster ||
									item.thumbs?.poster
								}
								alt="Video in gallery"
								iconSize={size || "medium"}
								sourceFull={item.media?.video || item?.video}
								sourcePreview={
									item.media?.thumbs?.preview_vertical ||
									item.thumbs?.preview_vertical
								}
							/>
						) : (
							<MediaImage
								width={item.width}
								height={item.height}
								maxHeight={isPhone ? 400 : 500}
								thumbnail={item.media?.big || item.images?.big}
								alt="Photo in gallery"
								size={size || "medium"}
							/>
						)}
					</StyledMediaTypeLink>
				</StyledMediaTypeContainer>
				<StyledMediaTypePaddingContainerMobile>
					{showDescription && item.description && (
						<Block mt={4}>
							{convertText({
								pieces: item.description,
							})}
						</Block>
					)}
					{!simple && children && <Block mt={3}>{children}</Block>}
				</StyledMediaTypePaddingContainerMobile>
			</StyledMediaTypeContainerFull>
		</>
	);
};

export default MediaType;

// #####################################################
